export default "__VITE_ASSET__D9$S_kHB__"